// Sends a browser-side failure to the server so it lands in the logs.
//
// Anything that breaks inside the buyer's browser — a third-party script that
// won't load, a device we don't have — leaves no trace server-side at all. We
// only hear about it secondhand, without a user agent or a reason. This is how
// the frontend says "this broke, here, on this device".
//
// Best effort by definition: never throws, never blocks the UI, and never
// reports its own failure.
import currentDomain from './Utils';

export default function reportClientError({ area, reason, detail }) {
  try {
    fetch(`${currentDomain(location)}/api/config/client-error`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        area,
        reason,
        detail: detail ? String(detail) : undefined,
        page: location.pathname,
      }),
      // The buyer may navigate away or close the tab the moment this fires.
      keepalive: true,
    }).catch(() => {});
  } catch {
    // A report that can't be sent is not worth breaking checkout over.
  }
}
